import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';

export function setFormErrors(errorsObj: any, form: UntypedFormGroup | UntypedFormArray): void {
  if (typeof errorsObj === 'string') {
    return;
  }

  if (Array.isArray(errorsObj)) {
    for (let i = 0; i < errorsObj.length; i++) {
      // @ts-ignore
      this.setErrorsAndScrollToThem(errorsObj[i]['children'], form?.controls[i]);
    }
    return;
  }

  for (const key in errorsObj) {
    if (!Object.prototype.hasOwnProperty.call(errorsObj, key)) {
      continue;
    }

    // if it has nested values
    // @ts-ignore
    if (errorsObj[key]['children'] && form.controls[key]) {
      // @ts-ignore
      const formGroup = form.controls[key];
      // @ts-ignore
      this.setErrorsAndScrollToThem(errorsObj[key]['children'], formGroup);
      continue;
    }

    if (typeof errorsObj[key] === 'object' && errorsObj[key] !== null && !Array.isArray(errorsObj[key])) {
      const errors = {};
      for (const err in errorsObj[key]) {
        if (Object.prototype.hasOwnProperty.call(errorsObj[key], err)) {
          // @ts-ignore
          errors[err] = errorsObj[key][err];
        }
      }
      // @ts-ignore
      if (Object.keys(errors).length > 0 && errors['errors'] && form.get(key)) {
        // @ts-ignore
        form.get(key).setErrors({ backend: { errors: errors['errors'][0] } });
      }
    } else if (form.get(key)) {
      // @ts-ignore
      form.get(key).setErrors({ backend: [errorsObj[key]] });
    }
  }
}
